import { FeatureFlag } from '../FeatureFlag';

export const enableUpdateNotifier = new FeatureFlag<'enabled' | 'disabled' | 'immediate'>({
    key: 'show-update-notifications',
    createdOn: '2025-01-30',
    defaultValue: 'disabled',
});
